import { defineStore } from "pinia";

export const advancedAlarmStore = defineStore("advancedAlarmStore", {
  state: () => ({
    editing: '',
    stateOnEdit: undefined,
  }),
  getters: {
    getEditing: (state) => state.editing,
    getStateOnEdit: (state) => state.stateOnEdit,
  },
  actions: {
    setEditing(type: string) {
      this.editing = type;
    },
    setStateOnEdit(state: any) {
      this.stateOnEdit = state;
    }
  },
});
